import type { SiteSettings } from '../types/admin'

type AddressSource = Pick<
  SiteSettings,
  | 'contact_address_street'
  | 'contact_address_city'
  | 'contact_address_state'
  | 'contact_address_zip'
  | 'contact_maps_url'
  | 'contact_maps_embed_url'
>

function buildAddressQuery(s: AddressSource): string | null {
  const parts = [
    s.contact_address_street,
    s.contact_address_city,
    s.contact_address_state,
    s.contact_address_zip,
  ].filter(Boolean)
  return parts.length > 0 ? parts.join(', ') : null
}

/** Returns the Google Maps directions URL — uses override if set, else derives from address. */
export function getMapsUrl(s: AddressSource): string | null {
  if (s.contact_maps_url) return s.contact_maps_url
  const q = buildAddressQuery(s)
  return q ? `https://maps.google.com/maps?q=${encodeURIComponent(q)}` : null
}

/** Returns the Google Maps embed URL — uses override if set, else derives from address. */
export function getMapsEmbedUrl(s: AddressSource): string | null {
  if (s.contact_maps_embed_url) return s.contact_maps_embed_url
  const q = buildAddressQuery(s)
  return q ? `https://maps.google.com/maps?q=${encodeURIComponent(q)}&output=embed` : null
}
